import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Option } from 'shared/components/ui/form-select';
import {
  NumberFormatOptions,
  numberFormatOptionToLabelMap,
} from 'shared/types/number-format-options';

export const useNumberFormatOptions = () => {
  const { t } = useTranslation();

  return useMemo<Option[]>(() => {
    return Object.values(NumberFormatOptions).map((format) => ({
      value: format,
      label:
        format === NumberFormatOptions.Auto
          ? t('forms.user-settings.number-format.label.auto')
          : numberFormatOptionToLabelMap[format],
    }));
  }, [t]);
};
